import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent
} from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import './sidebar.css';
import logo from '../../assets/images/logo/COLLEGELOGO.jpeg';
import { ProductContext } from "../../ProductProvider";

const Sidebar = ({
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedLeftChange,
  handleCollapsedRightChange
}) => {
  const { loggedUser, myProfileImage } = useContext(ProductContext);
  const location = useLocation();

  const isPathActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const handleLinkClick = () => {
    if (toggled && handleToggleSidebar) {
      handleToggleSidebar(false);
    }
  };

  return (
    <aside className="sidebar">
      <ProSidebar
        collapsed={collapsed}
        toggled={toggled}
        onToggle={handleToggleSidebar}
        breakPoint="md"
      >
        {/* Header */}
        <SidebarHeader>
          {collapsed ? (
            <div className="sidebar-collapsed-header">
              <button
                className="sidebar-toggle-btn"
                onClick={handleCollapsedRightChange}
                title="Expand Sidebar"
              >
                <i className="fa fa-chevron-right" aria-hidden="true"></i>
              </button>
              <img
                src={logo}
                alt="VJ Logo"
                className="sidebar-logo-badge"
                style={{ width: '36px', height: '36px', cursor: 'pointer' }}
                onClick={handleCollapsedRightChange}
                title="Expand Sidebar"
              />
            </div>
          ) : (
            <div>
              {/* College Branding Bar */}
              <div className="sidebar-brand-wrapper d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <img
                    src={logo}
                    alt="Vidyajyoti Crest"
                    className="sidebar-logo-badge"
                  />
                  <div>
                    <div className="sidebar-title-text">Vidyajyoti</div>
                    <div className="sidebar-subtitle-text">Student Portal</div>
                  </div>
                </div>

                <button
                  onClick={handleCollapsedLeftChange}
                  className="sidebar-toggle-btn"
                  title="Collapse Sidebar"
                >
                  <i className="fa fa-chevron-left" aria-hidden="true"></i>
                </button>
              </div>

              {/* Student Identity Card */}
              <div className="sidebar-student-card">
                <img
                  src={myProfileImage || logo}
                  alt={loggedUser.name || 'Student'}
                  className="sidebar-student-avatar"
                  onError={(e) => {
                    e.target.src = logo;
                  }}
                />
                <div className="sidebar-student-info">
                  <div className="sidebar-student-name" title={loggedUser.name || 'Student Portal'}>
                    {loggedUser.name || 'Student'}
                  </div>
                  <span className="sidebar-student-badge">
                    {loggedUser.profile || 'Student'}
                  </span>
                </div>
              </div>
            </div>
          )}
        </SidebarHeader>

        {/* Navigation Content */}
        <SidebarContent>
          <Menu iconShape="circle">
            <MenuItem
              active={isPathActive('/')}
              icon={<i className="fa fa-th-large" aria-hidden="true"></i>}
              title={collapsed ? "Dashboard" : undefined}
            >
              <Link to="/" onClick={handleLinkClick}>Dashboard</Link>
            </MenuItem>

            <MenuItem
              active={isPathActive('/course')}
              icon={<i className="fa fa-book" aria-hidden="true"></i>}
              title={collapsed ? "Courses" : undefined}
            >
              <Link to="/course" onClick={handleLinkClick}>Courses</Link>
            </MenuItem>

            <MenuItem
              active={isPathActive('/marksheet')}
              icon={<i className="fa fa-graduation-cap" aria-hidden="true"></i>}
              title={collapsed ? "Mark Sheet" : undefined}
            >
              <Link to="/marksheet" onClick={handleLinkClick}>Mark Sheet</Link>
            </MenuItem>

            <MenuItem
              active={isPathActive('/profile')}
              icon={<i className="fa fa-user" aria-hidden="true"></i>}
              title={collapsed ? "My Profile" : undefined}
            >
              <Link to="/profile" onClick={handleLinkClick}>My Profile</Link>
            </MenuItem>

            {loggedUser.profile === "Super Student" && (
              <SubMenu
                title="Web Administration"
                icon={<i className="fa fa-globe" aria-hidden="true"></i>}
              >
                <MenuItem
                  active={isPathActive('/slider-viewer')}
                  prefix={<i className="fa fa-sliders me-2" aria-hidden="true"></i>}
                >
                  <Link to="/slider-viewer" onClick={handleLinkClick}>Slider</Link>
                </MenuItem>
                <MenuItem
                  active={isPathActive('/gallery-viewer')}
                  prefix={<i className="fa fa-picture-o me-2" aria-hidden="true"></i>}
                >
                  <Link to="/gallery-viewer" onClick={handleLinkClick}>Gallery</Link>
                </MenuItem>
                <MenuItem
                  active={isPathActive('/infodesk')}
                  prefix={<i className="fa fa-newspaper-o me-2" aria-hidden="true"></i>}
                >
                  <Link to="/infodesk" onClick={handleLinkClick}>InfoDesk</Link>
                </MenuItem>
              </SubMenu>
            )}

            <MenuItem
              active={isPathActive('/change-password')}
              icon={<i className="fa fa-key" aria-hidden="true"></i>}
              title={collapsed ? "Security" : undefined}
            >
              <Link to="/change-password" onClick={handleLinkClick}>Security</Link>
            </MenuItem>
          </Menu>
        </SidebarContent>

        {/* Footer */}
        <SidebarFooter>
          {collapsed ? (
            <Link
              className="sidebar-logout-btn-collapsed"
              to="/logout"
              onClick={handleLinkClick}
              title="Sign Out"
            >
              <i className="fa fa-sign-out" aria-hidden="true"></i>
            </Link>
          ) : (
            <Link
              className="sidebar-logout-btn"
              to="/logout"
              onClick={handleLinkClick}
            >
              <i className="fa fa-sign-out" aria-hidden="true"></i>
              <span>Sign Out</span>
            </Link>
          )}
        </SidebarFooter>
      </ProSidebar>
    </aside>
  );
};

export default Sidebar;
